module.exports = __webpack_public_path__ + "img/document-icon-active.46bfd546.svg";